<template>
	<div>
		<Layout>
			<div class="preview" v-if="item && item.status != 'ACTIVE'">Vista Previa</div>
			<div class="container" v-if="item">
				<div class="row row-xs mt-sm-3">
					<div class="col-12" sticky-container>
						<div class="event-image" :class="{ 'without-image': !item.imageCover }">
							<div class="data">
								<div class="tags">
									<h4 class="category">{{ item.category.name }}</h4>
									<div class="age" v-if="item.minAge">{{ item.minAge }}+</div>
								</div>

								<h1>{{ item.name }}</h1>

								<div class="place-date">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										class="icon icon-tabler icon-tabler-map-pin"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										stroke-width="2"
										stroke="currentColor"
										fill="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
										<circle cx="12" cy="11" r="3"></circle>
										<path
											d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
										></path>
									</svg>
									<span>
										<span class="location">{{ item.location.name }}</span
										>, {{ item.location.locality.name }}
									</span>
								</div>
							</div>

							<img
								v-if="item.imageCover"
								:src="item.imageCover.url"
								:alt="item.title"
								class="img-fluid"
							/>
						</div>
					</div>

					<div class="col-12 content">
						<div class="sharing" v-sticky="true" sticky-offset="{top: 10}" sticky-side="both">
							<ShareButtons :link="item.publicLink" :title="`${item.title}`" />
						</div>

						<div class="row">
							<div class="col-12 col-lg-4 order-lg-last">
								<div
									class="event-data-card"
									v-sticky="true"
									sticky-offset="{top: 10}"
									sticky-side="both"
								>
									<div class="date">
										<span>
											{{ item.startAt | moment("DD MMM") }}
										</span>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-calendar-event"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<rect x="4" y="5" width="16" height="16" rx="2"></rect>
											<line x1="16" y1="3" x2="16" y2="7"></line>
											<line x1="8" y1="3" x2="8" y2="7"></line>
											<line x1="4" y1="11" x2="20" y2="11"></line>
											<rect x="8" y="15" width="2" height="2"></rect>
										</svg>
									</div>
									<div class="data-item">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-clock"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<circle cx="12" cy="12" r="9"></circle>
											<polyline points="12 7 12 12 15 15"></polyline>
										</svg>
										{{ item.startAt | moment("HH:mm") }} - {{ item.endAt | moment("HH:mm") }}
									</div>
									<hr />
									<div class="data-item">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-map-pin"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<circle cx="12" cy="11" r="3"></circle>
											<path
												d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
											></path>
										</svg>
										<div>
											<strong>{{ item.location.name }}</strong> <br />
											{{ item.location.address }},
											<span>{{ item.location.locality.name }}, </span>
											<span>{{ item.location.locality.region.name }}</span>
										</div>
									</div>
									<div class="data-item">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-coin"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<circle cx="12" cy="12" r="9"></circle>
											<path
												d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1 -1.8 -1"
											></path>
											<path d="M12 6v2m0 8v2"></path>
										</svg>
										<div>
											{{ item.prices }}
										</div>
									</div>
									<div class="data-item" v-if="item.phone">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-phone"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<path
												d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
											></path>
										</svg>
										<div>
											{{ item.phone }}
										</div>
									</div>
									<div class="data-item" v-if="item.url">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											class="icon icon-tabler icon-tabler-world"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											stroke-width="2"
											stroke="currentColor"
											fill="none"
											stroke-linecap="round"
											stroke-linejoin="round"
										>
											<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
											<circle cx="12" cy="12" r="9"></circle>
											<line x1="3.6" y1="9" x2="20.4" y2="9"></line>
											<line x1="3.6" y1="15" x2="20.4" y2="15"></line>
											<path d="M11.5 3a17 17 0 0 0 0 18"></path>
											<path d="M12.5 3a17 17 0 0 1 0 18"></path>
										</svg>
										<div>
											<a :href="item.url" target="_blank">{{ item.url }}</a>
										</div>
									</div>

									<div class="mt-4">
										<div class="btn btn-buy btn-primary btn-block" v-b-modal.buyTicketsModal>
											Comprar entradas
										</div>
									</div>

									<div class="mt-4 produced-by">
										<div v-if="item.account.logo" class="mr-1">
											<b-avatar rounded :size="48" :src="item.account.logo.urlThumb"></b-avatar>
										</div>
										<div class="flex-grow-1">
											Organiza:<br />
											<h5>{{ item.account.name }}</h5>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-lg-8 order-lg-first">
								<div class="mb-3">
									<MembershipBanner :eventId="item.id" />
								</div>

								<div class="alert-covid-required mb-3" v-if="item.requestCovidCertificate">
									<div>
										<img src="@/assets/img/icon-medical-shield.png" alt="" />
									</div>
									<div>
										<h5>Certificado covid-19</h5>
										<p>
											El evento require que todos los asistentes deban presentar su certificado de
											vacunación.<br />
											<small
												>El certificado puede ser descargado a través de la web:
												https://certificado.coronavirus.gub.uy/ o a través de la app Coronavirus
												UY</small
											>
										</p>
									</div>
								</div>

								<div class="description mb-5" v-html="item.description"></div>

								<div class="mb-5">
									<h4>Ubicación</h4>
									<div class="map" v-if="mapUrl">
										<img :src="mapUrl" class="img-fluid" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<b-modal id="buyTicketsModal" title="Selecciona tu entradas" hideFooter scrollable centered>
				<EventBuyTickets :event="item" />
			</b-modal>
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import EventBuyTickets from "./EventBuyTickets"
import MembershipBanner from "@/views/account/MembershipBanner"
import EventData from "@/views/events/EventData"
import ShareButtons from "@/components/ShareButtons"

export default {
	name: "Home",
	components: {
		Layout,
		EventBuyTickets,
		EventData,
		MembershipBanner,
		ShareButtons
	},
	data() {
		return {
			loading: false,
			item: null,
			mapUrl: null,
			previewCode: null
		}
	},

	async beforeMount() {
		this.previewCode = this.$route.query?.preview
		await this.load()
		if (this.item) {
			this.mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${this.item.location.latlng.lat},${this.item.location.latlng.lng}&zoom=15&size=640x300&maptype=roadmap&markers=${this.item.location.latlng.lat},${this.item.location.latlng.lng}&key=${process.env.VUE_APP_GOOGLE_API_KEY}`
		}

		if (this.$route.query.ref) this.$store.commit("savePromotorCode", this.$route.query.ref)
	},

	methods: {
		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($code: String!, $previewCode: String) {
							event(code: $code, previewCode: $previewCode) {
								id
								code
								account {
									id
									name
									logo {
										id
										type
										filename
										url
										urlThumb
									}
								}
								name
								startAt
								endAt
								description
								phone
								url
								minAge
								imageCover {
									id
									type
									filename
									url
									urlThumb
								}
								location {
									id
									name
									locality {
										id
										name
										region {
											id
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}
								category {
									id
									name
								}
								ticketGroups {
									id
									name
									ticketTypes {
										id
										name
										priceUnit
									}
								}
								publicLink
								requestCovidCertificate
								cancellationPolicy
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						code: this.$route.params.code,
						previewCode: this.previewCode
					},
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.loading = false
					this.item = data.event

					// obtengo el precio minimo y el maximo.
					const minPrice = this.item.ticketGroups.reduce((min, item) => {
						return item.ticketTypes.reduce((min, item) => {
							return item.priceUnit < min ? item.priceUnit : min
						}, min)
					}, Infinity)
					const maxPrice = this.item.ticketGroups.reduce((max, item) => {
						return item.ticketTypes.reduce((max, item) => {
							return item.priceUnit > max ? item.priceUnit : max
						}, max)
					}, 0)

					this.item.prices = `$${minPrice} - $${maxPrice}`

					return true
				})
				.catch((err) => {
					this.parseGQLErrors(err)
					this.$router.push("/")
					return null
				})
		}
	}
}
</script>

<style scoped lang="scss">
.preview {
	width: 100%;
	padding: 10px;
	font-size: 0.8rem;
	font-weight: 500;
	text-transform: uppercase;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #454398;
	color: #fff;
}
.event-image {
	background-color: #efefef;
	position: relative;
	overflow: hidden;
	border-radius: 16px;

	&:before {
		background: linear-gradient(180deg, transparent 12.99%, #000 69.25%);
		bottom: 0;
		content: "";
		left: 0;
		opacity: 0.7;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 1;
	}

	.data {
		position: absolute;
		bottom: 0px;
		left: 0;
		right: 0;
		padding: 2rem 3rem;
		color: #fff;
		z-index: 2;

		.tags {
			display: flex;
			align-items: center;

			& > * {
				margin-right: 6px;
				font-size: 0.7rem;
				background: #595959;
				border-radius: 4px;
				padding: 6px 10px;
				font-weight: 400;
				display: inline;

				line-height: 0.8rem;
				text-transform: uppercase;
			}
			.category {
				font-weight: 500;
			}
		}

		h1 {
			font-size: 2rem;
			line-height: 2.4rem;
			font-weight: 700;
			margin-top: 0.5rem;
		}
		.place-date {
			margin-top: 0.5rem;
			display: flex;
			align-items: center;
			font-size: 1rem;
			color: #cacaca;

			.location {
				color: #fff;
			}

			svg {
				margin-right: 8px;
				width: 18px;
			}
		}
	}
	img {
		width: 100%;
	}

	&.without-image {
		&:before {
			background: none !important;
		}
		.data {
			position: relative;
			color: #000;

			.tags {
				& > * {
					background: #b1b1b1;
				}
			}
			.place-date {
				color: #000;

				.location {
					color: #000;
				}
			}
		}
	}
}

.content {
	margin-top: 32px;
	padding: 32px 64px 32px 128px;
	position: relative;

	.sharing {
		position: absolute;
		margin-left: -42px;
		width: 36px !important;
	}
	.description {
		font-size: 1rem;
	}
}

.event-data-card {
	margin-bottom: 2rem;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
	background: #fff;
	border-radius: 8px;
	padding: 1rem;

	.date {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 1.2rem;
		font-weight: 700;
		color: #000;

		svg {
			flex-shrink: 0;
			color: rgb(138, 138, 138);
		}
	}

	.data-item {
		width: 100%;
		display: flex;
		align-items: center;

		font-size: 0.8rem;
		font-weight: 400;
		color: #000;
		margin-bottom: 12px;

		svg {
			flex-shrink: 0;
			width: 16px;
			margin-right: 6px;
			color: rgb(138, 138, 138);
		}
	}
}

.alert-covid-required {
	display: flex;
	align-items: center;
	border-radius: 8px;
	background-color: #dcf0f1;
	padding: 12px 10px;

	img {
		width: 82px;
	}
	p {
		margin: 0px;
	}
}

.map img {
	border-radius: 8px;
}

.produced-by {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
	font-size: 0.8rem;
	font-weight: 400;
	color: #000;

	h5 {
		font-size: 1.1rem;
		line-height: 0.9;
	}
}

@media (max-width: 576px) {
	.container {
		padding: 0px;
	}

	.event-image {
		border-radius: 0px;

		.data {
			padding: 1rem 2rem;
			h1 {
				font-size: 1.4rem;
				line-height: 1.8rem;
			}
		}
	}
	.content {
		margin-top: 0px;
		padding: 22px;
	}

	.event-data-card {
		box-shadow: none;
		padding: 0px;
	}

	.btn-buy {
		position: fixed;
		bottom: 6px;
		left: 16px;
		right: 16px;
		width: calc(100% - 32px);
		z-index: 10;
		height: 44px;
	}
}
</style>
